export const getTicketInvoicing = (state) => {
  return state.ticketInvoicing;
};

export const getSelectedTicketId = (state) => {
  const { ticketId } = getTicketInvoicing(state);
  return ticketId;
};

export const getIsDeferredJobView = (state) => {
  const { deferredJobView } = getTicketInvoicing(state);
  return deferredJobView;
};

export const getErrorMessage = (state) => {
  const { errorMessage } = getTicketInvoicing(state);
  return errorMessage;
};

export const getSorted = (state) => {
  const { sorted } = getTicketInvoicing(state);
  return sorted;
};
